import { withLazyLoading } from '@atlaskit/editor-common/lazy-node-view';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { taskItemNodeViewFactory } from './taskItem';
export var lazyTaskView = function lazyTaskView(portalProviderAPI, eventDispatcher, providerFactory, api) {
  if (editorExperiment('platform_editor_exp_lazy_node_views', false)) {
    return taskItemNodeViewFactory(portalProviderAPI, eventDispatcher, providerFactory, api);
  }
  return withLazyLoading({
    nodeName: 'taskItem',
    getNodeViewOptions: function getNodeViewOptions() {},
    loader: function loader() {
      var result = import( /* webpackChunkName: "@atlaskit-internal_editor-plugin-tasks-and-decisions_task-item-nodeview" */
      './taskItem').then(function (_ref) {
        var taskItemNodeViewFactory = _ref.taskItemNodeViewFactory;
        return function (node, view, getPos) {
          return taskItemNodeViewFactory(portalProviderAPI, eventDispatcher, providerFactory, api)(node, view, getPos);
        };
      });
      return result;
    }
  });
};